import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { useTheme } from '../../../theme';
const SIZE_CONFIG = {
    xs: { fontSize: '10px', letterSpacing: '0.04em' },
    sm: { fontSize: '12px', letterSpacing: '0.04em' },
    md: { fontSize: '14px', letterSpacing: '0.04em' },
    lg: { fontSize: '16px', letterSpacing: '0.04em' },
};
const FONT_FEATURE_SETTINGS = "'tnum' 1, 'zero' 1";
export const Coord = forwardRef(({ size = 'sm', color = 'muted', className, style, children, ...rest }, ref) => {
    const theme = useTheme();
    const resolveColor = (value) => {
        if (value === 'accent')
            return theme.colors.primary;
        if (value === 'muted')
            return theme.colors.textMuted;
        return 'inherit';
    };
    const { fontSize, letterSpacing } = SIZE_CONFIG[size];
    const coordStyles = {
        fontFamily: theme.typography.fontFamilyMono,
        fontSize,
        letterSpacing,
        fontFeatureSettings: FONT_FEATURE_SETTINGS,
        color: resolveColor(color),
        ...style,
    };
    return (_jsx("span", { ref: ref, className: className, style: coordStyles, ...rest, children: children }));
});
Coord.displayName = 'Coord';
